// Modal types constants
export const MODAL_TYPES = {
  INFO: 'INFO',
  RISK: 'RISK',
  UPDATE_RISK_SCORE: 'UPDATE_RISK_SCORE',
  REVIEW_RISK: 'REVIEW_RISK',
  MEASURE: 'MEASURE',
  UPGRADE: 'UPGRADE',
  SOA_IMPLEMENTED: 'SOA_IMPLEMENTED',
  ARCHIVE_RISK: 'ARCHIVE_RISK'
};
